"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var ApprovedStatusField = function (_a) {
    var record = _a.record;
    var t = (0, react_i18next_1.useTranslation)().t;
    if (!record)
        return null;
    var isApproved = !!record.version_approved_at;
    var formattedDate = isApproved
        ? new Date(record.version_approved_at).toISOString().split("T")[0]
        : null;
    return (react_1.default.createElement("div", { style: {
            backgroundColor: isApproved ? "var(--primary-color)" : "var(--warning-color)",
            color: "#fff",
            fontSize: "10px",
            fontFamily: "Geomanist-Bold",
            padding: "5px 10px",
            borderRadius: "4px",
            display: "inline-block",
            textAlign: "center",
            lineHeight: "1",
        }, title: isApproved
            ? t("Approved on {{date}}", { date: formattedDate })
            : t("Not yet approved") }, isApproved ? t("Approved") : t("Not Approved")));
};
exports.default = ApprovedStatusField;
